'use client';

import { FC, PropsWithChildren } from 'react';

import { AuthProvider } from '@sola/auth-sdk/components/auth-provider.js';
import { Sites, getPublicConfig } from '@sola/config/lib/getters.js';
import { SiteConfigResponseDto } from '@sola/schema/lib/contentful.js';

import { SiteConfigContext } from './context';

export const ContentfulProviders: FC<
  PropsWithChildren<{
    siteConfig?: SiteConfigResponseDto;
  }>
> = ({ children, siteConfig }) => {
  const publicConfig = getPublicConfig();
  const includeAuthProvider =
    publicConfig.NEXT_PUBLIC_SITE_ID !== Sites.enum.compex;

  const content = (
    <SiteConfigContext.Provider value={siteConfig}>
      {children}
    </SiteConfigContext.Provider>
  );

  return includeAuthProvider ? <AuthProvider>{content}</AuthProvider> : content;
};
